import { ApiIntegrationService } from '../api-types/service.api';
import { IntegrationService } from '../app-types/service.app';

/**
 * Transforms an API integration service to an app integration service.
 * @param input The API integration service to transform.
 * @returns The transformed app integration service.
 */
export function transformApiIntegrationServiceToAppIntegrationService(
	input: ApiIntegrationService,
): IntegrationService {
	return {
		id: input.id,
		shortName: input.shortName,
		name: input.name,
		soundex: input.soundex,
	};
}

/**
 * Transforms an array of API integration services to app integration services.
 * @param inputs The API integration services to transform.
 * @returns The transformed app integration services.
 */
export function transformApiIntegrationServicesToAppIntegrationServices(
	inputs: ApiIntegrationService[],
): IntegrationService[] {
	return inputs.map(transformApiIntegrationServiceToAppIntegrationService);
}
